import Head from "next/head";

export const ConvertTrackingExperiment = ({ isProd }) => {
  const environment = isProd ? "production" : "staging";
  return (
    <Head>
      <script
        type="text/javascript"
        async
        src={`//cdn-4.convertexperiments.com/v1/js/10016620-10017043.js?environment=${environment}`}
      ></script>
      <script
        dangerouslySetInnerHTML={{
          __html: `(function(){
            //disables the automatic body hiding of the convert script
            var _conv_prevent_bodyhide = true;
            //the duration, in mili seconds, for which the body is kept hidden if Convert tracking code does not load.
            var hideTimeout = 500; //modify this to whatever you think it's suitable

            var cssToHide = "body {visibility: hidden !important;}",
            headElement = document.head || document.getElementsByTagName("headElement")[0],
            styleElement = document.createElement("style");
            headElement.appendChild(styleElement);
            styleElement.type = "text/css";
            styleElement.id = "convert_hide_body";//do not change this
            if (styleElement.styleSheet){
            styleElement.styleSheet.cssText = cssToHide;
            } else {
            styleElement.appendChild(document.createTextNode(cssToHide));
            }
            setTimeout(function() {var c_h = document.getElementById("convert_hide_body"); if(c_h) c_h.outerHTML = "";}, hideTimeout)
            })();`,
        }}
      />
    </Head>
  );
};
